import { createContext, useContext } from 'react'
import { UNKNOWN_PLACEMENT } from './sourceToken'

/**
 * The placement segment of the betslip source token: the display_type
 * `FeedApp` actually mounted, which a `displayTypeOverride` can make differ
 * from the surface config. Cards rendered outside `FeedApp` report `unknown`.
 */
export const PlacementContext = createContext<string>(UNKNOWN_PLACEMENT)

export function usePlacement(): string {
  return useContext(PlacementContext)
}
